import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const HeaderTitle = styled.div`
  padding: 1.5rem 0 0 0;
  margin-left: 1rem;
  font-weight: bold;
  color: ${colors.BLACK};
  font-family: metropolis;
  text-align: left;
`;

export default {
  HeaderTitle,
};
